import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Hair_1 = ({ hairColours }) => {
  const primary = hairColours.base;
  const secondary = hairColours.shadow;

  return (
    <>
      <g>
        <path
          fill={primary}
          d="M505.3,429.2c-0.8,1.8-1.8,3.5-2.8,5.3c0,0,9.8-12.9,21.8-35.5c-1.1,3.6-2.4,7.9-3.9,12.4
		c2.3-3.1,5.1-5.7,8.4-7.8v-10.9c0.4-1.5,0.9-3.1,1.3-5c11.5-23.3,23.8-54.3,31.4-90.8c18.1-86.4-7.7-123.7-66.5-148.5
		c-37.3-15.8-139.2-22-180.5,10.9c-17,0.3-56.6,6.3-69.6,53.2c-9.2,33.2-3.4,95.7,27.6,161c0.9,6.9,2.7,14.2,4.1,19.2v5.5
		c2,1.2,3.8,2.5,5.5,4.1c-1-3.2-1.8-6.1-2.5-8.7c0.3-1.3,0.7-2.7,1-4c8.1,15.1,17.4,30.2,28.4,45c0,0-21.6-40.6-21.1-96.9
		c0.7-20.8,19.2-52.3,26.5-60c10.8,19.1,29.4,37.4,60.4,52.1c0,0-20.2-44.6-18.1-66.8c2.1,6.2,4.2,12.5,6.2,19
		c26.4,84.4,70.6,69.4,90.4,68.3c0,0-44.2-42.9-42.5-82.7c0.9,2.6,1.8,5.2,2.6,7.9c11.5,36.2,34.7,68,67.6,87c0.5,0.3,1,0.6,1.6,0.9
		C505.9,376.4,516.9,405.1,505.3,429.2z"
        />
        <path
          fill={secondary}
          d="M468,264.6c0,0,23.8,18.4,34.1,83c0,0,39.6-41.1,28.3-83c0,0,13.8,17.3,17.9,46.1c8.5-21.9,16.2-47.1,18.6-71
		c-2.7-47.5-28.1-73-71.9-91.5c-37.3-15.8-139.2-22-180.5,10.9c-17,0.3-56.6,6.3-69.6,53.2c-2.3,8.1-3.6,18-3.9,29.2
		c6.2,19.7,15.6,44,26.7,54.3c0,0,2.1-49.1,31-70.4c0,0,21.8,48.7,44.5,66.2c0,0-5.7-41.9,14-66.7c0,0,14.3,70.9,45.4,83.8
		c0,0-13.4-50.2,6.3-75c0,0,29.5,69.3,59,87C465.1,307.8,460.6,281.4,468,264.6z"
        />
        <path
          fill={primary}
          d="M427.5,170.5c-3.4-1-6.9-1.3-10.4-1.6c-12.3-0.9-24.6-1.9-36.9-2.8c12.7-3.1,25.7-4.7,38.7-4.9
		c5.3-0.1,10.7,0.1,15.7,1.8c14,4.8,23.8,20.7,38.5,20.3c-6.5,1.3-13.3,2.5-19.8,0.9C443.9,181.7,436.9,173.3,427.5,170.5z"
        />
        <path
          fill={primary}
          d="M305.6,176.4c-17.9,3-33.4,17.2-37.9,34.8c6.1-4.9,12.2-9.8,18.3-14.7C293.3,190.6,300.8,184.5,305.6,176.4z"
        />
        <path
          fill={primary}
          d="M320.5,226.4c5.6-15.3,13.7-31.6,8.5-47C320.7,193.4,317.6,210.4,320.5,226.4z"
        />
        <path
          fill={primary}
          d="M378.2,212.9c5.1-6.7,3.3-16.8-2.2-23.2c-5.5-6.4-13.8-9.6-21.9-11.4C367.4,184.5,377,198.2,378.2,212.9z"
        />
        <path
          fill={primary}
          d="M448.1,256.5c3.3-8.6,4.4-18.2,2.3-27.1c-2.1-9-7.6-17.3-15.4-22.1c4.9,9.3,3,20.9,7.1,30.5
		C444.6,244,449.6,250,448.1,256.5z"
        />
        <path
          fill={primary}
          d="M505.5,247.4c-2-5.2-6.2-10.3-11.8-10c5.9,12.5,8.9,26.4,8.7,40.2C508.1,268.7,509.3,257.2,505.5,247.4z"
        />
        <path
          fill={primary}
          d="M523.5,198.1c-7.6-4.5-17.3-5.4-23.9-11.2c10.1,8.4,19.3,17.8,27.5,28.1c4.6,5.8,9,12.5,8.3,19.9
		C541.1,221.9,535.7,205.2,523.5,198.1z"
        />
      </g>
    </>
  );
};

export default Hair_1;
